import React, { useReducer } from 'react';
import { CsvImportResponse } from '../../api/apiTypes';
import FileUpload from '../FileUpload';
import CsvImportResultDialog from '../CsvImportResultDialog';
import globalHandleError from '../../api/apiErrorHandle';

interface State {
  status: 'ready' | 'loading';
  response?: CsvImportResponse;
}

interface AvailabilityUploadProps {
  target: string;
}

const initialState: State = {
  status: 'ready',
  response: undefined,
};

type ResponseLoadAction = { type: 'response/load' };
type ResponseSetAction = { type: 'response/set', payload?: CsvImportResponse };
type Action = ResponseLoadAction | ResponseSetAction;

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'response/load':
      return { ...state, response: undefined, status: 'loading' };
    case 'response/set':
      return { ...state, response: action.payload, status: 'ready' };
    default:
      return state;
  }
}

export default function AvailabilityUpload(
  { target }: AvailabilityUploadProps,
): JSX.Element {
  const [state, dispatch] = useReducer(reducer, initialState);

  function handleStart(): void {
    dispatch({ type: 'response/load' });
  }

  function handleSuccess(response: CsvImportResponse): void {
    dispatch({ type: 'response/set', payload: response });
  }

  function handleClose() {
    dispatch({ type: 'response/set', payload: undefined });
  }

  function handleError(error: Error): void {
    globalHandleError(error);
    dispatch({ type: 'response/set', payload: undefined });
  }

  return (
    <>
      <FileUpload
        path={target}
        onStart={() => handleStart()}
        onError={(error) => handleError(error)}
        onSuccess={(response: CsvImportResponse) => handleSuccess(response)}
      >
        <div className="uploader">
          Click or Drag files to this area to upload
        </div>
      </FileUpload>
      <CsvImportResultDialog
        isLoading={state.status === 'loading'}
        response={state.response}
        onClose={() => handleClose()}
      />
    </>
  );
}
